import { useContext } from 'react';

import { HoneycombStoreContext } from '../context/honeycomb-store.context.js';
import { HoneycombSelectionState } from '../types/state.js';

const useSetState = () => {
  const { setState } = useContext(HoneycombStoreContext);

  return setState;
};

export const useSetStateSelection = () => {
  const setState = useSetState();

  return (newSelectionState: Partial<HoneycombSelectionState>) => {
    setState((prev) => ({
      ...prev,
      selection: {
        ...prev.selection,
        ...newSelectionState,
      },
    }));
  };
};
